import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';

import GenericErrorImage from './assets/GenericErrorImage.svg';

const i18n = defineMessages({
	errorStateHeaderTitle: {
		id: 'version-history.error-state.header.title',
		defaultMessage: 'Unable to load',
		description: 'Title for error state',
	},
	newRetryOrRefreshText: {
		id: 'version-history.error-state.new.retry.or.refresh.text',
		defaultMessage: 'We were unable to load history. Try again, or check your network connection.',
		description: 'Generalized text indicating issue with loading data and to retry or refresh page',
	},
	retryButtonText: {
		id: 'version-history.error-state.retry.button.text',
		defaultMessage: 'Retry',
		description: 'Button text to retry',
	},
});

const errorStateContainerStyles = xcss({
	flexGrow: 1,
});

type ErrorStateProps = {
	refetch: () => void;
};

export const ErrorState = ({ refetch }: ErrorStateProps) => {
	const { formatMessage } = useIntl();

	const handleRefetch = useCallback(() => {
		void refetch();
	}, [refetch]);

	return (
		<Box
			xcss={errorStateContainerStyles}
			paddingInline="space.600"
			paddingBlockEnd="space.600"
			testId="version-error-state"
		>
			<EmptyState
				header={formatMessage(i18n.errorStateHeaderTitle)}
				description={formatMessage(i18n.newRetryOrRefreshText)}
				primaryAction={
					<Button appearance="primary" onClick={handleRefetch}>
						{formatMessage(i18n.retryButtonText)}
					</Button>
				}
				imageUrl={GenericErrorImage}
			/>
		</Box>
	);
};
